import Box from 'assets/components/box/Box';

import { getLocales } from 'assets/locales/Locale';
import {
  AutomationRuleLike,
  AutomationRuleSchema,
  isLiteralExpressionType,
  isValuePropertyExpressionType,
} from '../helpers/AutomationTypes';
import {
  getExpressionDisplayValue,
  getEffectByPropertyPath,
  getPathIdEffectValues,
  getPrimaryExpression,
  getPropertyMetadata,
  isAnyExpression,
  isRangeExpression,
} from '../helpers/ruleHelpers';

type Props = {
  rule: AutomationRuleLike;
  schema: AutomationRuleSchema;
};

export default function AutomationReadonlySummary(props: Props) {
  const { lang, translate } = getLocales();
  const expression = getPrimaryExpression(props.rule);
  const metadata = getPropertyMetadata(props.schema, expression?.propertyPath);

  return (
    <Box style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.5rem' }}>
      {expression && (
        <>
          {lang.if}{' '}
          {!isLiteralExpressionType(expression.type) && (
            <strong>{metadata?.label || expression.propertyPath}</strong>
          )}{' '}
          {lang.is} <strong>{translate(expression.type)}</strong>
          {!isAnyExpression(expression) && !isValuePropertyExpressionType(expression.type) && (
            <>
              {isRangeExpression(expression) ? lang.between : lang.to}{' '}
              <strong>{getExpressionDisplayValue(expression, metadata)}</strong>
            </>
          )}
        </>
      )}
      {props.schema.effects.map((effect) => {
        if (effect.type === 'pathIdMultiSelect') {
          const selectedValues = getPathIdEffectValues(props.rule, effect);
          const selectedTitles = selectedValues
            .map((value) => effect.options?.find((option) => option.id === value)?.title || value)
            .join(', ');

          return (
            <span key={effect.propertyPathPrefix}>
              {effect.label}: <strong>{selectedTitles}</strong>
            </span>
          );
        }

        const currentEffect = getEffectByPropertyPath(props.rule, effect.propertyPath);
        const optionTitle =
          effect.options?.find((option) => option.id === currentEffect?.value)?.title || currentEffect?.value;

        return (
          <span key={effect.propertyPath}>
            {effect.label}: <strong>{optionTitle}</strong>
          </span>
        );
      })}
    </Box>
  );
}
